export default function TopBar({ title, subtitle, color, children }) {
  return (
    <div
      className="sticky top-0 z-20 backdrop-blur-md bg-white/80 border-b-2 border-[#ecebe6]"
      style={color ? { boxShadow: `inset 0 -4px 0 ${color}` } : undefined}
      data-testid="topbar"
    >
      <div className="max-w-[1600px] mx-auto px-4 md:px-6 py-3 flex items-center gap-4 flex-wrap">
        <div className="flex flex-col">
          <h1 className="text-2xl md:text-3xl font-display font-bold leading-none" data-testid="topbar-title">
            {title}
          </h1>
          {subtitle && (
            <span className="text-xs uppercase tracking-widest text-[var(--ink-soft)] mt-1">
              {subtitle}
            </span>
          )}
        </div>
        <div className="flex-1 flex items-center justify-end gap-3 flex-wrap">
          {children}
        </div>
      </div>
    </div>
  );
}
